module.exports = __webpack_public_path__ + "static/media/caution.87c3ca2c.png";